export interface COLOR_SCHEME {
  PRIMARY: string;
  SECONDARY: string;
  ACCENT: string;
  BACKGROUND: string;
  SURFACE: string;
  TEXT_PRIMARY: string;
  TEXT_SECONDARY: string;
  TEXT_MUTED: string;
  WHITE: string;
  BORDER: string;
  BORDER_DARK: string;
  ERROR: string;
  SUCCESS: string;
  WARNING: string;
  DISABLED: string;
  NAME: string;
  GRADIENT?: string;
  GRADIENT_OVERLAY_OPACITY?: number;
}

export const CLASSIC: COLOR_SCHEME = {
  PRIMARY: '#A8BF9E',
  SECONDARY: '#F0F5ED',
  ACCENT: '#8DA884',
  BACKGROUND: '#F9FBF7',
  SURFACE: '#E4ECE1',
  TEXT_PRIMARY: '#1F2B1C',
  TEXT_SECONDARY: '#556B53',
  TEXT_MUTED: '#7A8C76',
  WHITE: '#FFFFFF',
  BORDER: '#C8D5C3',
  BORDER_DARK: '#556B53',
  ERROR: '#B65D4D',
  SUCCESS: '#4A8C5E',
  WARNING: '#C28E42',
  DISABLED: '#A7B5A2',
  NAME: 'CLASSIC',
};

export const SUNNY: COLOR_SCHEME = {
  PRIMARY: '#FFD93D',
  SECONDARY: '#FFF6CC',
  ACCENT: '#F5C200',
  BACKGROUND: '#FFFEF7',
  SURFACE: '#FFFBE8',
  TEXT_PRIMARY: '#1A1A1A',
  TEXT_SECONDARY: '#6B5500',
  TEXT_MUTED: '#6B6B6B',
  WHITE: '#FFFFFF',
  BORDER: '#D0D0D0',
  BORDER_DARK: '#2E2E2E',
  ERROR: '#B42318',
  SUCCESS: '#1F8F5F',
  WARNING: '#C97A00',
  DISABLED: '#A6A6A6',
  NAME: 'SUNNY',
};

export const DARK: COLOR_SCHEME = {
  PRIMARY: '#000000',
  SECONDARY: '#3D3D3D',
  ACCENT: '#D4AF37',
  BACKGROUND: '#E5E5E5',
  SURFACE: '#000000',
  TEXT_PRIMARY: '#FFFFFF',
  TEXT_SECONDARY: '#FFFFFF',
  TEXT_MUTED: '#B0B0B0',
  WHITE: '#FFFFFF',
  BORDER: '#3D3D3D',
  BORDER_DARK: '#000000',
  ERROR: '#FF7A7A',
  SUCCESS: '#62D2A2',
  WARNING: '#F3C969',
  DISABLED: '#6E6E6E',
  NAME: 'DARK',
};

export const PINK: COLOR_SCHEME = {
  PRIMARY: '#F4A9AE',
  SECONDARY: '#FFF0F1',
  ACCENT: '#E7868C',
  BACKGROUND: '#FFFCFD',
  SURFACE: '#FFF5F6',
  TEXT_PRIMARY: '#2D1517',
  TEXT_SECONDARY: '#943E48',
  TEXT_MUTED: '#8B7378',
  WHITE: '#FFFFFF',
  BORDER: '#F4D5D7',
  BORDER_DARK: '#943E48',
  ERROR: '#C94F63',
  SUCCESS: '#2F9B77',
  WARNING: '#D48A35',
  DISABLED: '#C7AEB4',
  NAME: 'PINK',
};

export const SAGE_GREY: COLOR_SCHEME = {
  PRIMARY: '#A8BFB5',
  SECONDARY: '#E8EFEC',
  ACCENT: '#7A9C8E',
  BACKGROUND: '#F8FAF9',
  SURFACE: '#E0E8E4',
  TEXT_PRIMARY: '#1F2D27',
  TEXT_SECONDARY: '#5A6F66',
  TEXT_MUTED: '#7A8A82',
  WHITE: '#FFFFFF',
  BORDER: '#C5D2CC',
  BORDER_DARK: '#5A6F66',
  ERROR: '#B65454',
  SUCCESS: '#3C8D6D',
  WARNING: '#B78A41',
  DISABLED: '#A7B3AE',
  NAME: 'SAGE_GREY',
};

export const STEEL_BLUE: COLOR_SCHEME = {
  PRIMARY: '#5B8FB9',
  SECONDARY: '#E8F1F7',
  ACCENT: '#4A7A9E',
  BACKGROUND: '#F5FAFD',
  SURFACE: '#D1E4F0',
  TEXT_PRIMARY: '#1A2F3D',
  TEXT_SECONDARY: '#3D6A8A',
  TEXT_MUTED: '#6B8FA8',
  WHITE: '#FFFFFF',
  BORDER: '#B3D1E6',
  BORDER_DARK: '#3D6A8A',
  ERROR: '#C05555',
  SUCCESS: '#2F8A74',
  WARNING: '#D5943A',
  DISABLED: '#9BB4C6',
  NAME: 'STEEL_BLUE',
};

export const LILAC: COLOR_SCHEME = {
  PRIMARY: '#C8A2C8',
  SECONDARY: '#F5EEF5',
  ACCENT: '#B085B0',
  BACKGROUND: '#FDFBFD',
  SURFACE: '#F0E6F0',
  TEXT_PRIMARY: '#2D1A2D',
  TEXT_SECONDARY: '#623E62',
  TEXT_MUTED: '#8B7A8B',
  WHITE: '#FFFFFF',
  BORDER: '#DECCDE',
  BORDER_DARK: '#623E62',
  ERROR: '#B65C75',
  SUCCESS: '#4B9A7D',
  WARNING: '#C68C45',
  DISABLED: '#B9A8B9',
  NAME: 'LILAC',
};

export const MOCHA: COLOR_SCHEME = {
  PRIMARY: '#8B6F47',
  SECONDARY: '#F5F0E8',
  ACCENT: '#A0825C',
  BACKGROUND: '#FDFBF7',
  SURFACE: '#EDE5D8',
  TEXT_PRIMARY: '#2B1F10',
  TEXT_SECONDARY: '#5C4A31',
  TEXT_MUTED: '#8B7A65',
  WHITE: '#FFFFFF',
  BORDER: '#D4C4B0',
  BORDER_DARK: '#5C4A31',
  ERROR: '#B85C4A',
  SUCCESS: '#557F55',
  WARNING: '#C58A3D',
  DISABLED: '#B8AA96',
  NAME: 'MOCHA',
};

export const LIGHT_SAGE: COLOR_SCHEME = {
  PRIMARY: '#A8BF9E',
  SECONDARY: '#F0F5ED',
  ACCENT: '#8DA884',
  BACKGROUND: '#F9FBF7',
  SURFACE: '#E4ECE1',
  TEXT_PRIMARY: '#1F2B1C',
  TEXT_SECONDARY: '#556B53',
  TEXT_MUTED: '#7A8C76',
  WHITE: '#FFFFFF',
  BORDER: '#C8D5C3',
  BORDER_DARK: '#556B53',
  ERROR: '#B65D4D',
  SUCCESS: '#4A8C5E',
  WARNING: '#C28E42',
  DISABLED: '#A7B5A2',
  NAME: 'LIGHT_SAGE',
};

export const TERRACOTTA_CLAY: COLOR_SCHEME = {
  PRIMARY: '#C97064',
  SECONDARY: '#FBF3F0',
  ACCENT: '#B45A4D',
  BACKGROUND: '#FFFCFB',
  SURFACE: '#F7EBE7',
  TEXT_PRIMARY: '#2B1410',
  TEXT_SECONDARY: '#7D3B2F',
  TEXT_MUTED: '#9B6A5F',
  WHITE: '#FFFFFF',
  BORDER: '#E8C7C0',
  BORDER_DARK: '#7D3B2F',
  ERROR: '#B84E43',
  SUCCESS: '#4C8B61',
  WARNING: '#C98738',
  DISABLED: '#C9ADA7',
  NAME: 'TERRACOTTA_CLAY',
};

/** Deep blood red — barbershops, tattoo studios, boxing gyms */
export const BLOOD_RED: COLOR_SCHEME = {
  PRIMARY: '#8C1C13',
  SECONDARY: '#F7EDEC',
  ACCENT: '#6E1510',
  BACKGROUND: '#FFFCFC',
  SURFACE: '#F2DEDD',
  TEXT_PRIMARY: '#1A0505',
  TEXT_SECONDARY: '#6E1510',
  TEXT_MUTED: '#8C5050',
  WHITE: '#FFFFFF',
  BORDER: '#E8BFBE',
  BORDER_DARK: '#6E1510',
  ERROR: '#C94040',
  SUCCESS: '#3A7D57',
  WARNING: '#C98038',
  DISABLED: '#C4A5A3',
  NAME: 'BLOOD_RED',
};

/** Dark forest green — wellness, outdoors, sports recovery, men's grooming */
export const FOREST_GREEN: COLOR_SCHEME = {
  PRIMARY: '#2D5A27',
  SECONDARY: '#E6EFE5',
  ACCENT: '#1E3D1B',
  BACKGROUND: '#F6FAF5',
  SURFACE: '#D2E3CE',
  TEXT_PRIMARY: '#0F1E0D',
  TEXT_SECONDARY: '#2D5A27',
  TEXT_MUTED: '#5A7A56',
  WHITE: '#FFFFFF',
  BORDER: '#B5CEAF',
  BORDER_DARK: '#2D5A27',
  ERROR: '#C05050',
  SUCCESS: '#2D5A27',
  WARNING: '#C2882A',
  DISABLED: '#8BA886',
  NAME: 'FOREST_GREEN',
};

/** Midnight navy — premium barbers, men's spas, professional services */
export const MIDNIGHT_NAVY: COLOR_SCHEME = {
  PRIMARY: '#1B3A6B',
  SECONDARY: '#E6EBF4',
  ACCENT: '#122750',
  BACKGROUND: '#F4F6FB',
  SURFACE: '#CEDBEE',
  TEXT_PRIMARY: '#0A1628',
  TEXT_SECONDARY: '#1B3A6B',
  TEXT_MUTED: '#5A6E8A',
  WHITE: '#FFFFFF',
  BORDER: '#AEBFD9',
  BORDER_DARK: '#1B3A6B',
  ERROR: '#C04040',
  SUCCESS: '#2F8A6A',
  WARNING: '#D4943A',
  DISABLED: '#8A9FBB',
  NAME: 'MIDNIGHT_NAVY',
};

/** Burnt orange — fitness studios, barbershops, food/drink, high-energy service brands */
export const BURNT_ORANGE: COLOR_SCHEME = {
  PRIMARY: '#C8511A',
  SECONDARY: '#FDEEE7',
  ACCENT: '#8C3610',
  BACKGROUND: '#FDF6F2',
  SURFACE: '#F5CBB5',
  TEXT_PRIMARY: '#3D1508',
  TEXT_SECONDARY: '#C8511A',
  TEXT_MUTED: '#A0664E',
  WHITE: '#FFFFFF',
  BORDER: '#E8A98A',
  BORDER_DARK: '#C8511A',
  ERROR: '#B03030',
  SUCCESS: '#2F8A6A',
  WARNING: '#D4943A',
  DISABLED: '#D4A08A',
  NAME: 'BURNT_ORANGE',
};

/** Charcoal steel — barbershops, tattoo studios, gyms, near-black with warm gray surfaces */
export const CHARCOAL_STEEL: COLOR_SCHEME = {
  PRIMARY: '#1C1C1E',
  SECONDARY: '#E8E8EA',
  ACCENT: '#3A3A3C',
  BACKGROUND: '#F5F5F7',
  SURFACE: '#D1D1D6',
  TEXT_PRIMARY: '#0A0A0B',
  TEXT_SECONDARY: '#1C1C1E',
  TEXT_MUTED: '#6C6C70',
  WHITE: '#FFFFFF',
  BORDER: '#AEAEB2',
  BORDER_DARK: '#1C1C1E',
  ERROR: '#C04040',
  SUCCESS: '#2F8A6A',
  WARNING: '#D4943A',
  DISABLED: '#8E8E93',
  NAME: 'CHARCOAL_STEEL',
};

/** Deep burgundy — upscale men's grooming, cigar lounges, men's spas */
export const DEEP_BURGUNDY: COLOR_SCHEME = {
  PRIMARY: '#6B2737',
  SECONDARY: '#F2E8EA',
  ACCENT: '#4A1A26',
  BACKGROUND: '#FBF5F6',
  SURFACE: '#E4C8CD',
  TEXT_PRIMARY: '#2A0D12',
  TEXT_SECONDARY: '#6B2737',
  TEXT_MUTED: '#8A5560',
  WHITE: '#FFFFFF',
  BORDER: '#C9A0A8',
  BORDER_DARK: '#6B2737',
  ERROR: '#B03030',
  SUCCESS: '#2F8A6A',
  WARNING: '#D4943A',
  DISABLED: '#B08890',
  NAME: 'DEEP_BURGUNDY',
};

export const PRISM_RAINBOW: COLOR_SCHEME = {
  PRIMARY: '#7C3AED',
  SECONDARY: '#F5F3FF',
  ACCENT: '#DB2777',
  BACKGROUND: '#FFFBFE',
  SURFACE: '#EDE9FE',
  TEXT_PRIMARY: '#26133F',
  TEXT_SECONDARY: '#6D28D9',
  TEXT_MUTED: '#7C6F8F',
  WHITE: '#FFFFFF',
  BORDER: '#D8CCF3',
  BORDER_DARK: '#6D28D9',
  ERROR: '#BE123C',
  SUCCESS: '#047857',
  WARNING: '#B45309',
  DISABLED: '#A89DB8',
  NAME: 'PRISM_RAINBOW',
  GRADIENT: 'linear-gradient(120deg, #FF3CAC 0%, #FF7849 20%, #FFD43B 40%, #2DD4BF 60%, #38BDF8 78%, #A855F7 100%)',
  GRADIENT_OVERLAY_OPACITY: 0.18,
};

export const SUNSET_GLOW: COLOR_SCHEME = {
  PRIMARY: '#C2415D',
  SECONDARY: '#FFF1F2',
  ACCENT: '#EA580C',
  BACKGROUND: '#FFFAF8',
  SURFACE: '#FFE4DE',
  TEXT_PRIMARY: '#43141E',
  TEXT_SECONDARY: '#9F2442',
  TEXT_MUTED: '#94636A',
  WHITE: '#FFFFFF',
  BORDER: '#F3C4C8',
  BORDER_DARK: '#9F2442',
  ERROR: '#B91C1C',
  SUCCESS: '#047857',
  WARNING: '#B45309',
  DISABLED: '#C39A9F',
  NAME: 'SUNSET_GLOW',
  GRADIENT: 'linear-gradient(135deg, #FF8A1F 0%, #FF7697 52%, #D94670 100%)',
  GRADIENT_OVERLAY_OPACITY: 0.18,
};

export const OCEAN_AURORA: COLOR_SCHEME = {
  PRIMARY: '#0F766E',
  SECONDARY: '#ECFEFF',
  ACCENT: '#4F46E5',
  BACKGROUND: '#F7FCFD',
  SURFACE: '#D6F2F1',
  TEXT_PRIMARY: '#12313A',
  TEXT_SECONDARY: '#0F6670',
  TEXT_MUTED: '#5D7D84',
  WHITE: '#FFFFFF',
  BORDER: '#B8DEE0',
  BORDER_DARK: '#0F6670',
  ERROR: '#B91C1C',
  SUCCESS: '#047857',
  WARNING: '#B45309',
  DISABLED: '#92AFB3',
  NAME: 'OCEAN_AURORA',
  GRADIENT: 'linear-gradient(135deg, #2DD4BF 0%, #38BDF8 48%, #818CF8 100%)',
  GRADIENT_OVERLAY_OPACITY: 0.18,
};

export const BERRY_BLOOM: COLOR_SCHEME = {
  PRIMARY: '#9D174D',
  SECONDARY: '#FDF2F8',
  ACCENT: '#7E22CE',
  BACKGROUND: '#FFF9FC',
  SURFACE: '#FCE1F0',
  TEXT_PRIMARY: '#3B1028',
  TEXT_SECONDARY: '#861647',
  TEXT_MUTED: '#8D6379',
  WHITE: '#FFFFFF',
  BORDER: '#EDBFD7',
  BORDER_DARK: '#861647',
  ERROR: '#B91C1C',
  SUCCESS: '#047857',
  WARNING: '#B45309',
  DISABLED: '#BD94A9',
  NAME: 'BERRY_BLOOM',
  GRADIENT: 'linear-gradient(135deg, #F43F8E 0%, #D946EF 48%, #9333EA 100%)',
  GRADIENT_OVERLAY_OPACITY: 0.18,
};

export const GOLDEN_HOUR: COLOR_SCHEME = {
  PRIMARY: '#B45309',
  SECONDARY: '#FFF7E6',
  ACCENT: '#9A3412',
  BACKGROUND: '#FFFCF5',
  SURFACE: '#F8E5BD',
  TEXT_PRIMARY: '#3F2109',
  TEXT_SECONDARY: '#8B4108',
  TEXT_MUTED: '#927052',
  WHITE: '#FFFFFF',
  BORDER: '#E8C98F',
  BORDER_DARK: '#8B4108',
  ERROR: '#B91C1C',
  SUCCESS: '#047857',
  WARNING: '#A16207',
  DISABLED: '#B9A17D',
  NAME: 'GOLDEN_HOUR',
  GRADIENT: 'linear-gradient(135deg, #FBBF24 0%, #FB923C 52%, #EA580C 100%)',
  GRADIENT_OVERLAY_OPACITY: 0.18,
};

export const STANDARD_COLOR_SCHEME_NAMES = new Set([
  PRISM_RAINBOW.NAME,
  SUNSET_GLOW.NAME,
  OCEAN_AURORA.NAME,
  BERRY_BLOOM.NAME,
  GOLDEN_HOUR.NAME,
]);

/** Single source of truth — maps every scheme NAME string to its object. */
export const COLOR_SCHEME_BY_NAME: Record<string, COLOR_SCHEME> = {
  CLASSIC,
  SUNNY,
  DARK,
  PINK,
  SAGE_GREY,
  STEEL_BLUE,
  LILAC,
  MOCHA,
  LIGHT_SAGE,
  TERRACOTTA_CLAY,
  BLOOD_RED,
  FOREST_GREEN,
  MIDNIGHT_NAVY,
  CHARCOAL_STEEL,
  DEEP_BURGUNDY,
  BURNT_ORANGE,
  PRISM_RAINBOW,
  SUNSET_GLOW,
  OCEAN_AURORA,
  BERRY_BLOOM,
  GOLDEN_HOUR,
};

/** Resolves a stored scheme name to its COLOR_SCHEME, falling back to CLASSIC. */
export const resolveColorScheme = (schemeName?: string | null): COLOR_SCHEME =>
  (schemeName && COLOR_SCHEME_BY_NAME[schemeName]) ? COLOR_SCHEME_BY_NAME[schemeName] : CLASSIC;
